import React from 'react';
import { ArrowDownUp } from 'lucide-react';
import { TableHead } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import type { ReportSort, ReportSortKey } from '../types';

interface ReportsSortableHeaderProps {
  label: string;
  sortKey: ReportSortKey;
  sort: ReportSort | null;
  onSort: (_key: ReportSortKey) => void;
  className?: string;
  align?: 'left' | 'center';
}

export const ReportsSortableHeader: React.FC<ReportsSortableHeaderProps> = ({
  label,
  sortKey,
  sort,
  onSort,
  className,
  align = 'left',
}) => {
  const isActive = sort?.key === sortKey;

  return (
    <TableHead
      className={cn(
        'h-12 px-4 font-medium text-gray-500',
        align === 'center' && 'text-center',
        className
      )}
    >
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={cn(
          'inline-flex items-center gap-1.5 text-sm font-medium text-gray-500 hover:text-gray-800',
          align === 'center' && 'mx-auto'
        )}
      >
        {label}
        <ArrowDownUp
          className={cn('h-3.5 w-3.5 shrink-0', isActive ? 'text-gray-800' : 'text-gray-400')}
          strokeWidth={1.75}
        />
      </button>
    </TableHead>
  );
};
